import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const getRiaReferneceData = async (userid) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "riareferencedata",
        dat: {
            userid: userid,
        },
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaOrderRequirements = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetOrderRequirements",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaIntegrationGetTransferReasons = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetTransferReasons",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaCustomerTypes = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetCustomerTypes",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaIndustrySubCategory = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetIndustrySubCategory",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaSenderReceiverRelation = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationSenderReceiverRelation",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaBankRouteTypes = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetBankRouteTypes",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaBanks = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetBanks",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaPayoutPartnerLocations = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetPayoutPartnerLocations",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaTransactionFields = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetTransactionFields",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaIndustryCategory = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetIndustryCategory",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaMobileWallets = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetMobileWallets",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaAccountTypes = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetAccountTypes",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaStates = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetStates",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaPayoutPartners = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetPayoutPartners",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaFees = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaFees",
        dat: {}
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const createRiaDraftOrder = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationCreateDraftOrder",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaSendMoney = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "TransferMoney13",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaReceiveMoney = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "ReceiveMoney",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaSearchCashPickupOrder = async (refNumber) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationSearchCashPickupOrder",
        dat: {
          riapin: refNumber
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

    export const riaTrackTransaction = async (refNumber) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetTransactionStatus",
        dat: {
          refid: refNumber
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaCreateContact = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "createExternalContact",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaGetDeliveryMethods = async (country) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetDeliveryMethods",
        dat: {
          receivecountry: country
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaGetMobileWallets = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetMobileWallets",
        dat: formdata
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const getRiaIDTypes = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationGetMasterData",
        dat: {
          ...formdata,
          masterDataType: "BeneIDTypes"
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

    export const riaCancelTransaction = async (formdata) => {
    try {
      const data = JSON.stringify({
        svc: "ria",
        pid: "RiaIntegrationCancelOrder",
        dat: {
          ...formdata
        }
      });
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  export const riaCancelReasons = [
  {
    "id": 10,
    "value": "The transfer details were wrong"
  },
  {
    "id": 20,
    "value": "Change payout location"
  },
  {
    "id": 22,
    "value": "Issues at payout location"
  },
  {
    "id": 30,
    "value": "Transaction not collected on time"
  },
  {
    "id": 31,
    "value": "Order not accepted by payout location"
  },
  {
    "id": 32,
    "value": "Rejected by correspondent-Other"
  },
  {
    "id": 40,
    "value": "Duplicate order"
  },
  {
    "id": 41,
    "value": "Test transaction"
  },
  {
    "id": 50,
    "value": "Funds no longer needed"
  },
  {
    "id": 51,
    "value": "Requested by customer-Other"
  },
  {
    "id": 101,
    "value": "Credit card review reject"
  },
  {
    "id": 102,
    "value": "ACH returned item"
  },
  {
    "id": 103,
    "value": "The account has not been verified"
  },
  {
    "id": 104,
    "value": "ACH review reject"
  },
  {
    "id": 105,
    "value": "ACH cancellation with potential fraud case open > 75 days"
  },
  {
    "id": 111,
    "value": "Victim of fraud"
  },
  {
    "id": 112,
    "value": "Fraud stopped"
  },
  {
    "id": 114,
    "value": "Fraud confirmed"
  },
  {
    "id": 140,
    "value": "Rejected by compliance"
  },
  {
    "id": 190,
    "value": "Invalid account"
  },
  {
    "id": 200,
    "value": "Account holder mismatch"
  },
  {
    "id": 210,
    "value": "Inactive or closed account"
  },
  {
    "id": 220,
    "value": "Limit exceeded"
  },
  {
    "id": 230,
    "value": "Incorrect account currency"
  },
  {
    "id": 1016,
    "value": "Preference over different services"
  },
  {
    "id": 1019,
    "value": "Change delivery method"
  },
  {
    "id": 1022,
    "value": "Issues encountered on delivery address"
  },
  {
    "id": 1023,
    "value": "Country related unforeseen events"
  },
  {
    "id": 1024,
    "value": "Transaction not available on time"
  },
  {
    "id": 1028,
    "value": "Invalid amount"
  },
  {
    "id": 1030,
    "value": "Customer not able to provide documents"
  },
  {
    "id": 1034,
    "value": "External errors"
  },
  {
    "id": 1039,
    "value": "System Timeout"
  },
  {
    "id": 1040,
    "value": "Invalid bank routing code"
  },
  {
    "id": 1041,
    "value": "Payment not accepted by receiver"
  },
  {
    "id": 1042,
    "value": "Rejected by correspondent compliance"
  },
  {
    "id": 1043,
    "value": "Insufficient funds"
  },
  {
    "id": 1044,
    "value": "Invalid transfer reason"
  },
  {
    "id": 1045,
    "value": "Partner technical issue to process the transaction"
  },
  {
    "id": 1046,
    "value": "Invalid or missing sender details"
  },
  {
    "id": 1047,
    "value": "Invalid or missing beneficiary details"
  },
  {
    "id": 1048,
    "value": "Velocity limit exceeded"
  },
  {
    "id": 1049,
    "value": "Beneficiary is under age"
  },
  {
    "id": 1050,
    "value": "Beneficiary limit exceeded - current balance"
  },
  {
    "id": 1051,
    "value": "Beneficiary limit exceeded - weekly, monthly or yearly amount"
  },
  {
    "id": 1052,
    "value": "Beneficiary limit exceeded - daily amount"
  }
];
  